import styled, { css } from 'styled-components'

const designerCSS = css``

const developerCSS = css``

export const WithdrawPanelCSS = styled.div`
  ${designerCSS}
  ${developerCSS}
`
